import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ObserverPhotoDto } from '../models/observer-photo.model';

@Injectable({
  providedIn: 'root',
})
export class ObserverPhotoApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl.replace(/\/$/, '')}/api/observer/photos`;

  getPhoto(photoId: string): Observable<ObserverPhotoDto> {
    return this.http.get<ObserverPhotoDto>(`${this.baseUrl}/${encodeURIComponent(photoId)}`);
  }
}
